// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: stretch;
  height: 100vh;
  overflow: hidden;
  /*min-width: 1440px;*/
  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD","sourcesContent":["@import url(\"./global.css\");\n\n:host {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  align-items: stretch;\n  height: 100vh;\n  overflow: hidden;\n  /*min-width: 1440px;*/\n  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
